import { Form } from "frontend/src/components/Form/Form";
import DatePicker from "frontend/src/components/DatePicker/DatePicker";
import * as types from "_graphql-types/graphql";

import { endOfYear, getUnixTime, startOfYear } from "date-fns";
/* eslint-disable max-lines-per-function */
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import {
  removeFilter,
  updateFilter,
} from "Reducers/globalSearchV2/globalSearchV2.actions";
import { getInvestmentFilters } from "Reducers/globalSearchV2/globalSearchV2.selectors";
import { useDispatch } from "src/react-redux";
import { isNumber } from "../..";
import { FilterInterface } from "../FilterInterface";


const { Item } = Form;

function VintageYearFilter(): JSX.Element {
  const investmentFilters = useSelector(getInvestmentFilters);

  const dispatch = useDispatch();

  const vintageFilter = useMemo(() => {
    for (const filter of investmentFilters) {
      if (filter.type === "investment" && filter.data.type === "VINTAGE_YEAR") {
        return filter.data.data;
      }
    }
  }, [investmentFilters]);

  const defaultFilter: types.IntRangeFilter = {};

  const [localFilter, setLocalFilter] = useState(
    vintageFilter ?? defaultFilter
  );

  const reset = () => {
    dispatch(
      removeFilter({
        type: "investment",
        data: {
          type: "investment",
          data: {
            type: "VINTAGE_YEAR",
            data: defaultFilter,
          },
        },
      })
    );
  };

  const set = () => {
    if (isNumber(localFilter.min) || isNumber(localFilter.max)) {
      dispatch(
        updateFilter({
          type: "investment",
          data: {
            type: "investment",
            data: {
              type: "VINTAGE_YEAR",
              data: localFilter,
            },
          },
        })
      );
    }
  };

  return (
    <FilterInterface
      label="Vintage Year"
      count={vintageFilter ? 1 : 0}
      reset={reset}
      set={set}
      menuClass="filters__menu-dropdown-datepicker"
    >
      <div className="main-dropdown__menu-body">
        <div className="filters__interseption-datepicker-wrap">
          <Form labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
            <Item label="Start">
              <DatePicker
                data-cy="Vintage-Year-Start"
                onChange={(_, dateString) => {
                  setLocalFilter({
                    ...localFilter,
                    min: parseInt(String(dateString)),
                  });
                }}
                disabledDate={date => {
                  if (!localFilter.max) return false;
                  return (
                    date.unix() >
                    getUnixTime(endOfYear(new Date(localFilter.max, 1, 1)))
                  );
                }}
                picker="year"
              />
            </Item>
            <Item label="End">
              <DatePicker
                data-cy="Vintage-Year-End"
                onChange={(_, dateString) => {
                  setLocalFilter({
                    ...localFilter,
                    max: parseInt(String(dateString)),
                  });
                }}
                disabledDate={date => {
                  if (!localFilter.min) return false;
                  return (
                    date.unix() <
                    getUnixTime(startOfYear(new Date(localFilter.min, 1, 1)))
                  );
                }}
                picker="year"
              />
            </Item>
          </Form>
        </div>
      </div>
    </FilterInterface>
  );
}

export default VintageYearFilter;
